import { render } from "./SortTablePaginationComponent.vue?vue&type=template&id=403d3b4a&scoped=true"
import script from "./SortTablePaginationComponent.vue?vue&type=script&lang=js"
export * from "./SortTablePaginationComponent.vue?vue&type=script&lang=js"

import "./SortTablePaginationComponent.vue?vue&type=style&index=0&id=403d3b4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403d3b4a"]])

export default __exports__